export default __webpack_public_path__ + "static/media/title_pc@2x.83a5e626.png";